<div class="document-info-title">Vollständige Kontoverifizierung - wir erklären, wie es geht</div>
<div class="document-info-desc">Um dein Konto vollständig zu verifizieren, hast du drei Möglichkeiten zur Auswahl:</div>

<div class="document-info-box">
  <div class="info-row" (click)="MenuSelect(1)">
    <div class="first">
      <div class="item">A</div>
    </div>
    <div class="second">1-Cent Überweisung</div>
    <div class="third">
      <div class="item">
        <ng-container *ngIf="menuSelected == 1"> weniger Infos </ng-container>
        <ng-container *ngIf="menuSelected != 1"> mehr Infos </ng-container>
      </div>
    </div>
  </div>
  <div class="info-row" *ngIf="menuSelected == 1">
    <div class="rule-box">
      <div class="rule-row">
        <div class="empty"></div>
        <div class="rule">A: 1-Cent Überweisung</div>
      </div>
      <div class="rule-row">
        <div class="empty"></div>
        <div class="rule">1. Schritt: Starte deine Verifizierung indem du 1-Cent Überweisung anklickst und deine Daten zur Prüfung freigibst.</div>
      </div>
      <div class="rule-row">
        <div class="empty"></div>
        <div class="rule">2. Schritt: Gib im Eingabefeld deine IBAN ein und warte auf unsere 1-Cent Überweisung.</div>
      </div>
      <div class="rule-row">
        <div class="empty"></div>
        <div class="rule">3. Schritt: Logge dich in deiner Bank ein und kopiere den 1-Cent PIN. Diesen findest du im Verwendungszweck unserer Überweisung.</div>
      </div>
      <div class="rule-row">
        <div class="empty"></div>
        <div class="rule">
          4. Schritt: Füge sie im Eingabefeld 1-Cent PIN ein und klicke auf abschicken. Nach erfolgreicher Verifizierung wird dein Konto vollständig freigeschaltet.
        </div>
      </div>
    </div>
  </div>

  <div class="info-row" (click)="MenuSelect(2)">
    <div class="first">
      <div class="item">B</div>
    </div>
    <div class="second">Giropay ID</div>
    <div class="third">
      <div class="item">
        <ng-container *ngIf="menuSelected == 2"> weniger Infos </ng-container>
        <ng-container *ngIf="menuSelected != 2"> mehr Infos </ng-container>
      </div>
    </div>
  </div>

  <div class="info-row" *ngIf="menuSelected == 2">
    <div class="rule-box">
      <div class="rule-row">
        <div class="empty"></div>
        <div class="rule">1. Schritt: Klicke den Button Giropay ID an und gib im Eingabefeld deine IBAN an. Folge den weiteren Anweisungen.</div>
      </div>
      <div class="rule-row">
        <div class="empty"></div>
        <div class="rule">2. Schritt: Nach erfolgreicher Verifizierung wird dein Konto vollständig freigeschaltet.</div>
      </div>
      <div class="rule-row">
        <div class="empty"></div>
        <div class="rule">
          Folgende Banken unterstützen Giropay ID: Postbank, diverse Sparkassen und PSD Banken, Deutsche Kreditbank, Volksbanken und Raiffeisenbanken, GLS Gemeinschaftsbank,
          Comdirect Bank, Merkur Privatbank, MLP AG, Cronbank, Bankhaus Ellwanger & Geiger, Bankhaus Bauer und CVW Privatbank.
        </div>
      </div>
    </div>
  </div>

  <div class="info-row" (click)="MenuSelect(3)">
    <div class="first">
      <div class="item">C</div>
    </div>
    <div class="second">Gesichtserkennung (Video Ident)</div>
    <div class="third">
      <div class="item">
        <ng-container *ngIf="menuSelected == 3"> weniger Infos </ng-container>
        <ng-container *ngIf="menuSelected != 3"> mehr Infos </ng-container>
      </div>
    </div>
  </div>

  <div class="info-row" *ngIf="menuSelected == 3">
    <div class="rule-box">
      <div class="rule-row">
        <div class="empty"></div>
        <div class="rule">1. Schritt: Klicke auf den Button Gesichtserkennung, lade die Vorderseite deines Ausweises hoch und starte die automatische Video-Verifizierung.</div>
      </div>
      <div class="rule-row">
        <div class="empty"></div>
        <div class="rule">
          2. Schritt: Folge den Anweisungen (Bsp. verschiedene Gesichtsausdrücke) des Programms. Die Video-Verifizierung ist abgeschlossen, sobald alle 5 Punkte im Programm den
          Status OK haben.
        </div>
      </div>
      <div class="rule-row">
        <div class="empty"></div>
        <div class="rule">3. Schritt: Nach erfolgreicher Verifizierung wird dein Konto vollständig freigeschaltet.</div>
      </div>
    </div>
  </div>

  <div class="info-row" (click)="MenuSelect(4)">
    <div class="first">
      <div class="item">D</div>
    </div>
    <div class="second">Manuelle Ausweisüberprüfung</div>
    <div class="third">
      <div class="item">
        <ng-container *ngIf="menuSelected == 4"> weniger Infos </ng-container>
        <ng-container *ngIf="menuSelected != 4"> mehr Infos </ng-container>
      </div>
    </div>
  </div>

  <div class="info-row" *ngIf="menuSelected == 4">
    <div class="rule-box">
      <div class="rule-row">
        <div class="empty"></div>
        <div class="rule">
          Dieser Button erscheint, wenn der Adressen-Check von deiner Registrierung oder die Verifizierung über die automatische Gesichtserkennung fehlgeschlagen ist. Lade einfach
          deine Ausweisdokumente hoch, warte auf die manuelle Überprüfung und vervollständige danach deine Verifizierung.
        </div>
      </div>

      <div class="rule-row">
        <div class="empty"></div>
        <div class="rule">
          <div class="info-button-box">
            <div class="text">Klicke hier für die manuelle Ausweisprüfung und lade deine Dokumente hoch</div>
            <div class="button" (click)="UploadPage2()">MANUELLE PRÜFUNG</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="info-button-box">
    <div class="text">Wähle zwischen 1-Cent Überweisung, Giropay ID oder Gesichtserkennung</div>
    <div class="button" (click)="UploadPage()">HIER VERIFIZIEREN</div>
  </div>

  <div class="info-box">
    <div class="main-title">Wichtige Infos</div>

    <div class="title">Giropay ID und Gesichtserkennung</div>

    <div class="text">
      Nach der erfolgreichen Verifizierung musst du dich von WETTARENA abmelden und dich erneut mit deinem Benutzernamen und Passwort anmelden, um deine Konto-Verifizierung
      abzuschließen.
    </div>

    <div class="title">Warum müssen wir dich überprüfen?</div>

    <div class="text">
      Die zusätzliche Verifizierung basiert auf rechtlichen Bestimmungen in Deutschland, die wir einhalten müssen. Du profitierst nach der erfolgreichen Verifizierung aber auch
      zusätzlich von einer schnellen und unkomplizierten Auszahlung. Wir nehmen Datenschutz und Sicherheit sehr ernst. Deine Dokumente werden mit einer hochsicheren Lösung
      hochgeladen. Wir werden dein Konto so schnell wie möglich überprüfen, nachdem alle angeforderten Dokumente hochgeladen wurden.
    </div>

    <div class="title">Identität</div>

    <div class="text">
      Wenn dies gefordert wird, benötigen wir einen Identitätsnachweis. Dazu kannst du ein Dokument hochladen, in dem alle Informationen (einschließlich deines Fotos) deines
      gültigen Ausweises (z.B. Reisepasses oder Personalausweises) sichtbar sind.
    </div>

    <div class="title">Adressnachweis</div>

    <div class="text">
      Zur Bestätigung deiner Adresse akzeptieren wir Telefon-, Internet-, Wasser- und / oder Stromrechnungen. Wir akzeptieren auch Bank- oder Steuererklärungen. Bitte beachte, dass
      das Datum des Dokuments nicht älter als 3 Monate sein darf und dass wir deinen Namen, deine Adresse und das Firmen- / Banklogo sehen müssen. Wir müssen auch alle 4 Ecken
      sehen können.
    </div>

    <div class="title">Zahlungsmethode</div>

    <div class="text">
      Wir benötigen Unterlagen, die belegen, dass du der Inhaber der Zahlungsmethode bist, die du für Einzahlungen und / oder Auszahlungen bei WETTARENA verwendest. Für
      Banküberweisungen lade bitte ein Dokument hoch, das deinen Namen, deine Adresse und das Banklogo eindeutig enthält. Dieses Dokument darf nicht älter als 3 Monate sein
    </div>
  </div>
</div>
